import { Link } from "react-router-dom";
import { CatalogCta, CatalogHero, CatalogLayout, SolutionCards } from "../components/catalog";
import { SOLUTIONS } from "../data/solutions";

export function SolutionsPage() {
  return (
    <CatalogLayout title="Solutions">
      <CatalogHero
        label="Start with the task"
        title="Solutions"
        intro="Three starting points for data production, robot experiments and multimodal research. Define the outcome, then select the hardware, software and services."
      />
      <section className="catalog-wrap catalog-section catalog-first">
        <SolutionCards />
        <div className="catalog-table-scroll" tabIndex={0} aria-label="Solution comparison">
          <table>
            <caption>Choose your starting point</caption>
            <thead>
              <tr>
                <th>Solution</th>
                <th>Who it serves</th>
                <th>Core deliverables</th>
              </tr>
            </thead>
            <tbody>
              {SOLUTIONS.map((e) => (
                <tr key={e.slug}>
                  <th scope="row">
                    <Link to={`/solutions/${e.slug}`}>{e.name}</Link>
                  </th>
                  <td>{e.audience}</td>
                  <td>{e.outcome}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      <CatalogCta />
    </CatalogLayout>
  );
}
